/** Keep the real WhatsApp link from covering primary storefront actions. */
class FreyaFloatingChat extends HTMLElement {
  #abort;
  #resize;
  #body;
  #frame = 0;

  connectedCallback() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    const options = { capture: true, passive: true, signal: this.#abort.signal };
    document.addEventListener('scroll', this.#schedule, options);
    window.addEventListener('resize', this.#schedule, options);
    window.addEventListener('load', this.#schedule, options);
    this.#resize = new ResizeObserver(this.#schedule);
    const main = document.querySelector('main');
    if (main) this.#resize.observe(main);
    this.#body = new MutationObserver(this.#schedule);
    this.#body.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    this.#schedule();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#resize?.disconnect();
    this.#body?.disconnect();
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
  }

  #schedule = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      const link = this.querySelector('a');
      if (!link) return;
      const widget = link.getBoundingClientRect();
      const actions = document.querySelectorAll('main .freya-homepage-details__contact-action, main .freya-hero__cta, main .freya-bestsellers__all-link, main button[type="submit"], [data-freya-price-form] > a');
      const overlap = [...actions].some(action => {
        const rect = action.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && widget.left < rect.right && widget.right > rect.left && widget.top < rect.bottom && widget.bottom > rect.top;
      });
      link.toggleAttribute('data-cta-overlap', overlap);
    });
  };
}

if (!customElements.get('freya-floating-chat')) customElements.define('freya-floating-chat', FreyaFloatingChat);
